<template>
    <div class="BrokerDisclaimerPreSignUp">
        <Retailnavbar> </Retailnavbar>
        <BrokerDisclaimerComponent></BrokerDisclaimerComponent>
        <RetailFooter></RetailFooter>
    </div>
</template>

<script>
import BrokerDisclaimerComponent from "@/components/BrokerDisclaimerComponent.vue";
import RetailFooter from "@/components/RetailSideCompo/RetailFooter.vue";
import Retailnavbar from "@/components/RetailSideCompo/RetailNavbar.vue";

export default {
    name: 'BrokerDisclaimerPreSignUp',
    components: {
        RetailFooter, Retailnavbar, BrokerDisclaimerComponent
    },
    mixins: [],

    data() {
        return {
            nav_title: 'Broker Disclaimer'
        }
    },
}
</script>